import React from "react";
import cx from "classnames";
import Icon from "../../assets/icons/Icon";
import styles from "./DimensionIcon.module.scss";

/**
 * @returns icon container with correct colour
 */
export default function DimensionIcon(props) {
  const { dimension, className } = props;
  if (dimension === "Sustainable Operating Model") {
    return (
      <IconContainer
        icon="GtRecycle"
        className={cx(styles.icon_container_teal, className)}
      />
    );
  }

  if (dimension === "Capabilities") {
    return (
      <IconContainer
        icon="GtHammer"
        className={cx(styles.icon_container_orange, className)}
      />
    );
  }

  if (dimension === "Culture") {
    return (
      <IconContainer
        icon="GtPeopleTeam"
        className={cx(styles.icon_container_red, className)}
      />
    );
  }

  if (dimension === "Technology") {
    return (
      <IconContainer
        icon="GtComputerLaptop"
        className={cx(styles.icon_container_purple, className)}
      />
    );
  }

  if (dimension === "Data") {
    return (
      <IconContainer
        icon="GtComputerServers"
        className={cx(styles.icon_container_gray, className)}
      />
    );
  }

  if (dimension === "Customer") {
    return (
      <IconContainer
        icon="GtHandshakeHeart"
        className={cx(styles.icon_container_green, className)}
      />
    );
  }
}

function IconContainer(props) {
  const { className, icon } = props;
  return (
    <div className={cx(styles.icon_container, className)}>
      <Icon icon={icon} className={styles.icon_svg} />
    </div>
  );
}
